import { useEffect } from 'react'
import { useBackendThreadMessages } from './useBackendThreadMessages'
import { useBackendThreadsList } from './useBackendThreadsList'
import { usePollThreadMessages } from './usePollThreadMessages'
import { useWorkspaceChatScope } from './useWorkspaceChatScope'

/** Hydrate sidebar + open-thread messages from the conversations API. */
export function useBackendThreadSync(model) {
  const { displayThreadId, navThreads, setActiveProjectId, setPinnedThreadIds, setThreads } = model
  useWorkspaceChatScope(model)
  useBackendThreadsList(setThreads, setPinnedThreadIds)
  useBackendThreadMessages(model)
  usePollThreadMessages(model)

  useEffect(() => {
    if (!displayThreadId) return
    const thread = navThreads.find((item) => item.id === displayThreadId)
    if (thread && 'projectId' in thread) setActiveProjectId(thread.projectId ?? null)
  }, [displayThreadId, navThreads, setActiveProjectId])
}
